import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';

import Banner from 'images/logo.png';
import HomeButton from 'components/HomeButton';

const HeaderContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  padding-top: 60px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media(max-width: 706px){
    margin-top: 70px;
  }

  @media(max-width: 362px){
    margin-top: 85px;
  }
`;

const Img = styled.img`
  @media(max-width: 384px){
    width: 100%;
  }
`;


class Header extends React.Component {
  render() {
    return (
      <HeaderContainer>
        <HomeButton onClick={() => {window.location.href = 'https://medarbeiderne.no';}}>
          <i className="fas fa-home" style={{ fontSize: 30 }}/>
        </HomeButton>
        <a href="/">
          <Img src={Banner} alt="Banner" />
        </a>
        <div style={{ width: 40 }}/>
      </HeaderContainer>
    );
  }
}

/* Header.propTypes = {
  history: PropTypes.any,
} */

export default Header;
